import { useParams } from "react-router-dom";

import { useLayoutStore } from "@type/store";
import { useTranslationContext } from "context/TranslationContext";
import cn from "lib/cn";

const PageNotFound = () => {
  const { t } = useTranslationContext();
  const { buSlug } = useParams();
  const isDataNotFound = useLayoutStore((state) => state.isDataNotFound);

  const handleClick = () => {
    window.location.href = `/${buSlug}`;
  };

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center",
        isDataNotFound
          ? "-ml-8 -mr-8 -mt-8  h-[calc(100vh-6.85rem)] bg-white"
          : "h-full"
      )}
    >
      <img
        width={412}
        height={165}
        className="max-w-[25.rem] max-h-[14rem] mb-11"
        src="/images/404.webp"
      />
      <h1 className="text-hsBlue-500 text-2xl font-bold mb-5">
        {t("page_not_found")}
      </h1>
      <p className="text-lg text-[#404040]">{t("not_found.message")}</p>
      <button
        onClick={handleClick}
        className="mt-10 py-3 px-12 text-white bg-dodgerBlue-500 rounded-lg text-base"
      >
        {t("go_to_home")}
      </button>
    </div>
  );
};

export default PageNotFound;
